var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 12.2144C8.60551 12.2144 8.28571 12.5342 8.28571 12.9286V15.7858C8.28571 16.1802 8.60551 16.5001 8.99999 16.5001C9.39446 16.5001 9.71427 16.1802 9.71427 15.7858V12.9286C9.71427 12.5342 9.39446 12.2144 8.99999 12.2144Z",
    fill: "#FAD15F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 1.5C8.60551 1.5 8.28571 1.81981 8.28571 2.21428V3.64285C8.28571 4.03732 8.60551 4.35713 8.99999 4.35713C9.39446 4.35713 9.71427 4.03732 9.71427 3.64285V2.21428C9.71427 1.81981 9.39446 1.5 8.99999 1.5Z",
    fill: "#FAD15F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42858 8.64275C5.42858 8.24827 5.10877 7.92847 4.7143 7.92847H1.85717C1.46269 7.92847 1.14288 8.24827 1.14288 8.64275C1.14288 9.03722 1.46269 9.35703 1.85717 9.35703H4.7143C5.10877 9.35703 5.42858 9.03722 5.42858 8.64275Z",
    fill: "#FAD15F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1428 7.92847H13.2857C12.8912 7.92847 12.5714 8.24827 12.5714 8.64275C12.5714 9.03722 12.8912 9.35703 13.2857 9.35703H16.1428C16.5373 9.35703 16.8571 9.03722 16.8571 8.64275C16.8571 8.24827 16.5373 7.92847 16.1428 7.92847Z",
    fill: "#FAD15F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46439 11.1682L3.44416 13.1885C3.16526 13.4675 3.16526 13.9197 3.44416 14.1987C3.58364 14.3381 3.76645 14.4078 3.94926 14.4078C4.13206 14.4078 4.31487 14.3381 4.45435 14.1987L6.47463 12.1783C6.75353 11.8994 6.75353 11.4471 6.47458 11.1682C6.19563 10.8892 5.74339 10.8892 5.46439 11.1682Z",
    fill: "#FAD15F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0304 6.32658C12.2132 6.32658 12.396 6.25687 12.5355 6.11734L14.5557 4.09702C14.8347 3.81807 14.8347 3.36583 14.5557 3.08688C14.2768 2.80798 13.8245 2.80793 13.5456 3.08688L11.5253 5.10721C11.2464 5.38616 11.2464 5.83839 11.5253 6.11734C11.6648 6.25687 11.8476 6.32658 12.0304 6.32658Z",
    fill: "#FAD15F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5355 11.1682C12.2566 10.8893 11.8043 10.8892 11.5253 11.1681C11.2464 11.4471 11.2464 11.8993 11.5253 12.1783L13.5456 14.1986C13.6851 14.3381 13.8679 14.4078 14.0507 14.4078C14.2334 14.4078 14.4163 14.338 14.5557 14.1986C14.8347 13.9196 14.8347 13.4674 14.5557 13.1885L12.5355 11.1682Z",
    fill: "#FAD15F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidate);
export default __webpack_public_path__ + "static/media/validate.283aad9bb5470b4bbe9b19d5baf1f1e9.svg";
export { ForwardRef as ReactComponent };